<template>
  <div class="announcement">
    <div v-if="!showTable">
      <Button type="primary" @click="showTable=true;isAdd=true">{{$t("front.addBulltin")}}</Button>
      <LidaTable :propscolumns="colums" :data="data" :propsPageSize="pageSize" />
    </div>
    <AnnouncementTable
      v-if="showTable"
      :siteList="siteList"
      :showTable.sync="showTable"
      :isAdd.sync="isAdd"
      @getAnnounceData="getAnnounceData"
      :adid="adid"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'announcement-setting',
  components: {
    AnnouncementTable: () => import('./components/announcementTable.vue')
  },
  data () {
    return {
      showTable: false,
      isAdd: false,
      adid: 0,
      data: [],
      pageSize: 20,
      siteList: [],
      colums: {
        // id: {
        //   title: this.$t('common.identifier'),
        //   key: 'id',
        //   align: 'center',
        //   width: 60
        // },
        datetime: {
          title: this.$t('common.date&time'),
          key: 'datetime',
          align: 'center',
          width: 150
        },
        site: {
          title: this.$t('front.useSite'),
          key: 'site',
          align: 'center',
          width: 140
        },
        gameclass: {
          title: this.$t('common.gameClass'),
          key: 'gameclass',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('span', this.getName(params.row.gameclass))
          }
        },
        content: {
          title: this.$t('front.bulltinDetails'),
          key: 'content',
          align: 'center',
          minWidth: 250
        },
        lv1: {
          title: this.$t('navlist.operator'),
          key: 'lv1',
          align: 'center',
          width: 60,
          render: (h, params) => {
            if (params.row.lv1 == 1) {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#108110'
                }
              }, 'V')
            } else {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#f00'
                }
              }, 'X')
            }
          }
        },
        lv2: {
          title: this.$t('common.level2'),
          key: 'lv2',
          align: 'center',
          width: 60,
          render: (h, params) => {
            if (params.row.lv2 == 1) {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#108110'
                }
              }, 'V')
            } else {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#f00'
                }
              }, 'X')
            }
          }
        },
        lv3: {
          title: this.$t('common.level3'),
          key: 'lv3',
          align: 'center',
          width: 60,
          render: (h, params) => {
            if (params.row.lv3 == 1) {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#108110'
                }
              }, 'V')
            } else {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#f00'
                }
              }, 'X')
            }
          }
        },
        lv4: {
          title: this.$t('common.level4'),
          key: 'lv4',
          align: 'center',
          width: 40,
          render: (h, params) => {
            if (params.row.lv4 == 1) {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#108110'
                }
              }, 'V')
            } else {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#f00'
                }
              }, 'X')
            }
          }
        },
        lv5: {
          title: this.$t('common.level5'),
          key: 'lv5',
          align: 'center',
          width: 40,
          render: (h, params) => {
            if (params.row.lv5 == 1) {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#108110'
                }
              }, 'V')
            } else {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#f00'
                }
              }, 'X')
            }
          }
        },
        lv6: {
          title: this.$t('common.level6'),
          key: 'lv6',
          align: 'center',
          width: 40,
          render: (h, params) => {
            if (params.row.lv6 == 1) {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#108110'
                }
              }, 'V')
            } else {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#f00'
                }
              }, 'X')
            }
          }
        },
        lv7: {
          title: this.$t('common.level7'),
          key: 'lv7',
          align: 'center',
          width: 40,
          render: (h, params) => {
            if (params.row.lv7 == 1) {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#108110'
                }
              }, 'V')
            } else {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#f00'
                }
              }, 'X')
            }
          }
        },
        disorder: {
          title: this.$t('front.showOrder'),
          key: 'disorder',
          align: 'center',
          width: 70
        },
        spbounce: {
          title: this.$t('front.importantbulltin'),
          key: 'spbounce',
          align: 'center',
          width: 70,
          render: (h, params) => {
            if (params.row.spbounce == 1) {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#108110'
                }
              }, 'V')
            } else {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#f00'
                }
              }, 'X')
            }
          }
        },
        bounce: {
          title: this.$t('front.loginModal'),
          key: 'bounce',
          align: 'center',
          width: 70,
          render: (h, params) => {
            if (params.row.bounce == 1) {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#108110'
                }
              }, 'V')
            } else {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#f00'
                }
              }, 'X')
            }
          }
        },
        valid: {
          title: this.$t('system.valid'),
          key: 'valid',
          align: 'center',
          width: 40,
          render: (h, params) => {
            if (params.row.valid == 1) {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#108110'
                }
              }, 'V')
            } else {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#f00'
                }
              }, 'X')
            }
          }
        },
        action: {
          title: this.$t('common.operate'),
          key: 'action',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.isAdd = false
                    this.showTable = true
                    this.adid = params.row.id
                  }
                }
              }, this.$t('common.modify')),
              h('span', { style: { margin: '0px 5px' } }, '/'),
              h('a', {
                style: {

                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      content: `${this.$t('message.askDelBulletin')} ？`,
                      onOk: () => {
                        this.$axios.setting.adde({ adid: params.row.id, loid: this.getmember.pid })
                          .then(res => {
                            if (res.status != 1) return this.$Message.error(this.$t('message.failure'))
                            this.$Message.success(this.$t('message.success'))
                            this.getAnnounceData()
                          })
                          .catch(err => console.error(err))
                      }
                    })
                  }
                }
              }, this.$t('common.delect'))
            ])
          },
        },
      }
    }
  },
  computed: {
    ...mapGetters(['getmember', 'getAllGame']),
  },
  mounted () {
    this.getAnnounceData()
  },
  methods: {
    async getAnnounceData () {
      try {
        this.siteList = await this.$axios.setting.sitelist()
        const res = await this.$axios.setting.anlt(0)
        if ('status' in res && res.status === 0) return
        res.forEach(item => {
          item.site = item.stid_list.split(',').reduce((text, id, ind) => {
            const sitename = this.siteList.find(it => it.id == id).memname
            text += (ind+1) == item.stid_list.split(',').length
              ? `${sitename}`
              : `${sitename}, `
            return text
          }, '')
        });
        this.data = res.reverse()
      } catch (error) {
        console.error(error)
      }
    },
    getName (val) {
      if (val == 0) return this.$t('common.all')
      let obj = this.getAllGame.filter(it => it.gameid == val)[0]
      return obj.gamename
    }
  }
}
</script>